import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../../../styles/colorVariables';
import { Sizes } from '../../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      backgroundColor: colorVariables.blueLight,
      color: theme.palette.text.primary,
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      borderRadius: 10,
      boxShadow: '1px 1px 16px rgba(12, 82, 112, 0.08)',
      '& .MuiAlert-icon': {
         padding: 0,
         marginRight: theme.spacing(1.5),
         alignSelf: 'center',
      },
      '& .MuiAlert-message': {
         flexGrow: 1,
         padding: theme.spacing(0.5, 0),
      },
      '& .MuiAlert-action': {
          marginRight: 0,
          paddingLeft: theme.spacing(2),
          alignSelf: 'center',
          [theme.breakpoints.down(Sizes.mobile)]: {
            margin: 0,
          },
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
      },
    },
    avatar: {
      backgroundColor: colorVariables.blue,
      color: '#ffffff',
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    title: {
      fontWeight: 700,
      fontSize: 14,
      color: colorVariables.navy,
    },
    description: {
      fontWeight: 400,
      fontSize: 14,
      color: colorVariables.navy,
    },
    upgradeButton: {
      backgroundColor: colorVariables.blue,
      color: '#ffffff',
      borderRadius: '20px',
      textTransform: 'none',
      padding: theme.spacing(0.8, 2.5),
      marginRight: 25,
      '&:hover': {
        backgroundColor: colorVariables.blue,
      },
    },
    closeButton: {
      position: 'absolute',
      color: colorVariables.grey60,
      top: 4,
      right: 4,
    }
  }),
);
